import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
} from "@mui/material"
import React, { useContext, useMemo } from "react"
import { pagesUrl } from "../core/appConstants"
import { OrganizationContext } from "../core/context/organization/organization-context"
import { Transition } from "./dialog/BaseDialog"

interface IProps {
  isOpen: boolean

  handleClose(): void
}

// TODO: Déplacer lors de la création d'une variante beem shot
export function SubscribeDialog({ handleClose, isOpen }: Readonly<IProps>): React.JSX.Element {
  const { organization } = useContext(OrganizationContext)

  const projectCount: string = useMemo(() => {
    if (organization?.maxProjectEstimationCount === -1) {
      return "Illimité"
    } else if (organization?.maxProjectEstimationCount !== undefined) {
      return `${organization.maxProjectEstimationCount}`
    } else {
      return "0"
    }
  }, [organization?.maxProjectEstimationCount])

  return (
    <Dialog open={isOpen} fullWidth maxWidth="md" TransitionComponent={Transition}>
      <DialogTitle>Plus de licence disponible</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Votre organisation ne disposent plus de licences suffisantes. Voici le récapitulatif :
        </DialogContentText>
        <List>
          <Box>
            <ListItem>
              <ListItemText
                primary="Nombre de projets"
                secondary={
                  <Box display="flex" flexDirection="row" gap={1}>
                    <Box>Licences actuelles disponibles : {projectCount}</Box>-{" "}
                    <Box>Licences Consommées : {organization?.projectEstimationCounter ?? 0}</Box>
                  </Box>
                }
              />
            </ListItem>
            <Divider />
          </Box>
        </List>
        <DialogContentText sx={{ pt: 2 }}>
          Pour plus d'informations, veuillez consulter la page <Link href={pagesUrl.MY_OFFER_PAGE}>mon offre </Link>
          ou contactez-nous à l'adresse <Link href="mailto:contact@timetobeem.com">contact@timetobeem.com</Link>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}
